/**
 * @constructor
 * @implements {Foundation.Session.Manager.Delegate}
 */
Foundation.Facebook.SessionManagerDelegate = function () {};

Foundation.Facebook.SessionManagerDelegate.prototype.sessionManagerID = function () {
    return "facebook";
};

Foundation.Facebook.SessionManagerDelegate.prototype.logOut = function () {
    var app = Foundation.Facebook.Application.sharedInstance();
    return app ? app.logOut() : (new Foundation.Promise()).fail();
};

Foundation.Facebook.SessionManagerDelegate.prototype.revalidateLogin = function () {
    var app = Foundation.Facebook.Application.sharedInstance();
    if (app) {
        app.then(function () {
            FB.getLoginStatus(function (response) {
                if (response["authResponse"] || response["session"]) {
                    app.sessionChange(response);
                }
            });
        });
    }
};

Foundation.Facebook.SessionManagerDelegate.prototype.observeExternalSessionEvents = function () {
    var app = Foundation.Facebook.Application.sharedInstance();
    if (app) {
        app.listenForAuthResponseChange();
    }
}

Foundation.Facebook.SessionManagerDelegate.prototype.unobserveExternalSessionEvents = function () {
    var app = Foundation.Facebook.Application.sharedInstance();
    if (app) {
        app.unlistenForAuthResponseChange();
    }
}
